import React, {useCallback, useState} from 'react';
import styled, {css} from 'styled-components';
import useSubscription from '../../hooks/useSubscription';
import {EVENT_ID} from '../../../../containers/event_manager';

type ZenModeProps = {
	hidden: boolean;
};
const ZenMode = styled.div<ZenModeProps>`
	${({hidden}) =>
		hidden &&
		css`
			display: none;
		`}
`;

type ZenModeableProps = {
	children: React.ReactNode;
};
export const ZenModeable = ({children}: ZenModeableProps): React.ReactNode => {
	const [zenModeActive, setZenModeActive] = useState(false);

	const onZenModeEvent = useCallback(() => {
		setZenModeActive(!zenModeActive);
	}, [zenModeActive]);

	useSubscription(EVENT_ID.ZEN_MODE_TOGGLED, onZenModeEvent);

	return <ZenMode hidden={zenModeActive}>{children}</ZenMode>;
};
